<template>
  <!-- SH026 — on a channel set to "let the customer switch", this is the switch: the two
       ways into the appointment, side by side, with the one being used marked. Only ever
       rendered on the first of the two steps, so it offers a choice rather than a way to
       walk out of a half-made booking. -->
  <div class="salon-flowtoggle" role="tablist" :aria-label="$t('salon.flowToggle.ariaLabel')">
    <button
      v-for="option in options"
      :key="option.value"
      class="salon-flowtoggle-btn"
      :class="{ 'salon-flowtoggle-btn--on': option.value === order }"
      type="button"
      role="tab"
      :aria-selected="String(option.value === order)"
      @click="$emit('switch', option.value)"
    >
      {{ $t(option.labelKey) }}
    </button>
  </div>
</template>

<script>
export default {
  name: "SalonFlowToggle",
  props: {
    // "date" or "staff" — which of the two the customer is answering right now.
    order: {
      type: String,
      default: "date",
    },
  },
  emits: ["switch"],
  data() {
    return {
      options: [
        { value: "date", labelKey: "salon.flowToggle.pickDate" },
        { value: "staff", labelKey: "salon.flowToggle.chooseStylist" },
      ],
    };
  },
};
</script>

<style scoped>
/* Tokens come from src/salon/styles/tokens.css, namespaced under .salon-app — this
   component always renders inside one, so they resolve by inheritance. */
.salon-flowtoggle {
  display: flex;
  gap: 4px;
  padding: 4px;
  margin-bottom: var(--salon-stack-md);
  background: var(--salon-surface-container-low);
  border: 1px solid var(--salon-border);
  border-radius: 999px;
}

.salon-flowtoggle-btn {
  flex: 1;
  padding: 10px 12px;
  border: 0;
  border-radius: 999px;
  background: transparent;
  color: var(--salon-on-surface-variant);
  font-family: var(--salon-font-body);
  font-size: 14px;
  font-weight: 500;
  line-height: 1.2;
  cursor: pointer;
  transition: background 0.18s ease, color 0.18s ease;
}

.salon-flowtoggle-btn--on {
  background: var(--salon-surface-lowest);
  color: var(--salon-on-surface);
  font-weight: 600;
  box-shadow: var(--salon-shadow-soft);
}
</style>
